/* ============================================================================
   Shared tab controller — used by M11 (science tabs) and M22 (timeline tabs).
   One implementation, driven entirely by data attributes so any future
   tabbed module can adopt it without new JS: `[data-tabs]` on the root,
   `role="tablist"` on the tab row, `[data-tab]` on each tab button and
   `[data-panel]` on each panel. Order of the two node lists must match.
   ========================================================================= */
(function () {
  'use strict';

  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var list = root.querySelector('[role="tablist"]');
    var tabs = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    if (!list || !tabs.length || !panels.length) return;

    var initialised = false;

    function show(index) {
      Array.prototype.forEach.call(tabs, function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        // The tab row is a horizontal scroll rail below 700px, so an
        // arrow-key move can activate a tab that is off-screen. `nearest` on
        // both axes scrolls the rail only when it has to, and never scrolls
        // the page — `block: 'nearest'` is what stops the document jumping to
        // the tablist. Skipped on init so first paint does not scroll.
        if (on && initialised && tab.scrollIntoView) {
          tab.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        }
      });
      Array.prototype.forEach.call(panels, function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        // `hidden` is native, needs no companion CSS to fail safe, and is the
        // one place JS removes a panel from layout/a11y tree — every panel
        // still ships visible in the markup for JS-off (contract rule 7).
        panel.hidden = !on;
      });
    }

    Array.prototype.forEach.call(tabs, function (tab, i) {
      tab.addEventListener('click', function () { show(i); });
    });

    // Roving arrow-key navigation — same idiom as strum-gallery.js's rail:
    // arrow keys move focus and activate immediately (no separate Enter step).
    list.addEventListener('keydown', function (e) {
      var current = Array.prototype.indexOf.call(tabs, document.activeElement);
      if (current === -1) return;
      var next;
      if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else return;
      e.preventDefault();
      tabs[next].focus();
      show(next);
    });

    // JS-enhanced init only: activates tab 0 and hides the rest. Runs once,
    // after the JS-off markup (all panels visible) has already done its job.
    show(0);
    initialised = true;
  });
})();
